<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="一覧" icon="format-list-bulleted">
			<b-button slot="button" type="is-success" @click="$router.push({ name: 'preset-new' })">新規作成</b-button>

			<b-table
				:loading="isLoading"
				:paginated="true"
				:per-page="$consts.TABLE_PER_PAGE"
				:striped="true"
				:hoverable="true"
				default-sort="name"
				:data="list"
				@page-change="onPageChange"
				>

				<template slot-scope="props">
					<b-table-column label="プリセット名" field="name" sortable>
						{{ props.row.name }}
					</b-table-column>
					<b-table-column label="チーム数" field="team_count">
						{{ props.row.team_count }}
					</b-table-column>
					<b-table-column label=" ">
						<div class="buttons is-right">
							<button class="button is-small is-warning" type="button" @click="$router.push({ name: 'preset-edit', params: { presetId: props.row.id }})">編集</button>
							<button class="button is-small is-danger" type="button" @click="onDeleteClick(props.row.id)">削除</button>
						</div>
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<table-empty :loading="isLoading"></table-empty>
				</section>

				<section class="page-info" slot="bottom-left">
					<page-info :current="currentPage" :data="list"></page-info>
				</section>
			</b-table>
		</card-component>
	</div>

</template>

<style lang="scss" scoped>
.search-wrap {
	flex: 1;

	.search-type,
	.row {
		display: flex;
		align-items: center;
	}

	.search-title {
		margin-right: 10px;
	}
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'Preset',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
	},
	data() {
		return {
			isLoading: false,
			list: [],
			currentPage: 1,
		}
	},
	computed: {
		titleStack () {
			return [
				'プリセット管理'
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;
			let ep = 'presets';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.list = res.data.list;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onDeleteClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			this.isLoading = true;
			let ep = 'presets/' + id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);
				this.list.some(function(v, i){
					if (v.id === id) this.list.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange: function(val) {
			this.currentPage = val;
		},
	},
}
</script>
